/** Thin horizontal progress bar — track + colored fill. */
export function ProgressBar({ pct, color }: { pct: number; color: string }) {
  return (
    <div className="w-full h-1.5 bg-gray-200/80 rounded-full overflow-hidden">
      <div
        className="h-full rounded-full transition-all"
        style={{
          width: `${Math.min(Math.max(pct, 0), 100)}%`,
          backgroundColor: color,
        }}
      />
    </div>
  );
}
